export default[
    {
        path: '/data/paperCard',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '纸质套餐录入',
            authLogin: true
        }
    }, 
    // {
    //     path: '/data/paperCard/edit',
    //     component: resolve => require(['../edit.vue'], resolve),
    //     meta: {
    //         title: '新增纸质套餐',
    //         authLogin: true
    //     }
    // },
    // {
    //     path: '/data/paperCard/detail/:id',
    //     component: resolve => require(['../detail.vue'], resolve),
    //     meta: {
    //         title: '消费详情',
    //         authLogin: true
    //     }
    // },
]